import { render, staticRenderFns } from "./faceFive.vue?vue&type=template&id=750b3a74&"
import script from "./faceFive.vue?vue&type=script&lang=js&"
export * from "./faceFive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports